$(document).on('click', '.js-showToggleText', function() {
  $(this).parents('.js-toggleText').toggleClass('is_active');
});